import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/atoms/card";

interface CompletionStepProps {
  onReset: () => void;
}

export const CompletionStep = ({ onReset: _onReset }: CompletionStepProps) => {
  const { t } = useTranslation();

  const placeholder = "Completion step content";

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t(($) => $.library.onboardDocuments.steps.completion.cardTitle)}
        </CardTitle>
        <CardDescription>
          {t(
            ($) => $.library.onboardDocuments.steps.completion.cardDescription,
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-sm">{placeholder}</p>
      </CardContent>
    </Card>
  );
};
